<template>
  <div class="photo-box-1">
    <div class="box">
      <div class="photo">
        <div
          class="img"
          v-bind:style="{ 'background-image': 'url(' + imageUrl + ')' }"
        ></div>
      </div>
      <div class="description">
        <div class="date">{{ data.date }}</div>
        <div class="under-bar"></div>
        <div class="location">{{ data.placeName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { firebaseConnection } from '../../library/firebase'
export default {
  name: 'photo-box-1',
  props: {
    data: {
      representativeImage: '',
      date: '2017 03 01',
      location: 'LONDON'
    },
    type: Object
  },
  data() {
    return {
      date: '2017 03 01',
      location: 'LONDON',
      imageUrl: ''
    }
  },
  created() {
    // this.mainImage()
  },
  mounted() {
    this.$nextTick(this.imageLoad)
  },
  methods: {
    imageLoad() {
      return firebaseConnection
        .storage()
        .ref(this.data.uploaded[0].thumbnailFullPath)
        .getDownloadURL()
        .then(url => {
          this.imageUrl = url
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-box-1 {
  width: 240px;
  height: 320px;
  display: block;
  .box {
    position: relative;
    width: inherit;
    height: inherit;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    .photo {
      width: inherit;
      height: 240px;
      position: relative;
      overflow: hidden;
      display: block;
      .img {
        width: 100%;
        height: 100%;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        transition: all 1s;
        animation: photoLoad ease-in-out;
        /*animation-delay: 1s;*/
        animation-duration: 2s;
        animation-fill-mode: forwards;
        opacity: 0;
      }

      @keyframes photoLoad {
        from {
          opacity: 0;
        }

        to {
          opacity: 1;
        }
      }
    }
    &:hover {
      .photo .img {
        transform: scale(1.2);
      }
    }
    .description {
      width: 221px;
      height: 83px;
      background-color: #f5f5f5;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-left: 19px;
      padding-top: 15px;
      .date {
        width: 200px;
        height: 26px;
        font-family: Poppins;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 1px;
        text-align: left;
        color: #000000;
        display: block;
      }

      .under-bar {
        margin-top: 8px;
        width: 20px;
        height: 1px;
        background-color: #ab08b6;
        display: block;
      }

      .location {
        margin-top: 10px;
        width: 100%;
        height: 26px;
        display: block;
        font-family: Poppins;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 1px;
        color: #000000;
      }
    }
  }
}
</style>
